export const checkIsLastData = (index, totalData) => index === totalData - 1;
export const checkIsFirstData = (index) => index === 0;
